<template>
  <px-autocomplete-cadastro-adicional-multiple
    v-if="metadata"
    dense
    :label="metadata.label"
    :type="metadata.type"
    v-bind="$attrs"
    @blur="onBlur"
    class="rounded-tag-small required"
    v-model="localValue"/>
</template>

<script>
export default {
  props: {
    value: Array,
    metadata: {
      type: Object,
    },
    label: {
      type: String,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
};
</script>
